/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { NotificationEmailDeliveriesControllerFindAllQueryResponse, NotificationEmailDeliveriesControllerFindAllQueryParams, NotificationEmailDeliveriesControllerFindAll401, NotificationEmailDeliveriesControllerFindAll403 } from "../../models/notificationEmailDeliveriesController/NotificationEmailDeliveriesControllerFindAll";

function getNotificationEmailDeliveriesControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/notification-email-deliveries` as const }  
  return res
}

/**
 * @description Per-delivery outcomes for the email pipeline. A job row covers a chunk of up to fifty deliveries, so the jobs list cannot answer what happened to one recipient.
 * @summary List notification email deliveries
 * {@link /api/v1/notification-email-deliveries}
 */
export async function notificationEmailDeliveriesControllerFindAll(params?: NotificationEmailDeliveriesControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<NotificationEmailDeliveriesControllerFindAllQueryResponse, ResponseErrorConfig<NotificationEmailDeliveriesControllerFindAll401 | NotificationEmailDeliveriesControllerFindAll403>, unknown>({ method : "GET", url : getNotificationEmailDeliveriesControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}